/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { GmaoBarChartController } from './GmaoBarChart';

class GmaoEquipmentAvailabilityMetricController extends GmaoBarChartController {
    $onInit() {
        super.$onInit();

        this.chartOptions.chart.color = [this.configuration.CHART_COLORS.DEFAULT_COLOR];
        this.chartOptions.chart.yDomain = [0, 100];
        this.chartOptions.chart.valueFormat = record => d3.format(',.1f')(record);
        this.chartOptions.chart.yAxis = { axisLabel: '%' };

        this.chartData = [{
            key: 'equipmentAvailability',
            values: [this.data]
        }];
    }
}

export const gmaoEquipmentAvailabilityMetricComponent = {
    controller: GmaoEquipmentAvailabilityMetricController,
    template: require('./gmao-chart.html'),
    bindings: {
        data: '='
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoEquipmentAvailabilityMetric.js